import { useI18nContext } from "@hopper-b2b/i18n";

export const useMinutesToHoursAndMinutes = (timeInMinutes: number) => {
  const { t } = useI18nContext();

  const hours = Math.floor(timeInMinutes / 60);
  const minutes = timeInMinutes % 60;

  if (hours === 0 && minutes === 0) {
    return;
  }

  const hoursText = t("core-activities.time.hours", { count: hours });
  const minutesText = t("core-activities.time.minutes", { count: minutes });

  if (hours === 0) {
    return minutesText;
  }

  if (minutes === 0) {
    return hoursText;
  }

  return `${hoursText}, ${minutesText}`;
};
